import React, {Component} from "react";

export default class ShowVoucher extends Component {
  render() {
    return <div>ShowVoucher</div>;
  }
}
